import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Login from './Login';

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/api\/v1$/, '') || '';

const StandaloneLogin: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [appName, setAppName] = useState('');
  const [appIcon, setAppIcon] = useState('');

  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigate(`/app/${slug}/index`, { replace: true });
      return;
    }
    fetch(`${API_BASE}/api/v1/sub_app/${slug}/public-info`)
      .then(res => res.ok ? res.json() : null)
      .then(data => { if (data?.name) setAppName(data.name); if (data?.icon) setAppIcon(data.icon); })
      .catch(() => {});
  }, [slug, navigate]);

  return <Login title={appName} icon={appIcon} redirectTo={`/app/${slug}/index`} />;
};

export default StandaloneLogin;
